import React, { useState, useEffect } from "react";
import AOS from "aos";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import { IMAGES } from "../Library/photos";

import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";

import "../assets/css/Gallery.css";

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    AOS.refresh();
  }, []);

  const openLightbox = (index) => {
    setSelectedIndex(index);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setSelectedIndex(null);
    document.body.style.overflow = "auto";
  };

  const nextImage = () => {
    setSelectedIndex((prev) => (prev === IMAGES.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setSelectedIndex((prev) => (prev === 0 ? IMAGES.length - 1 : prev - 1));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex]);

  useEffect(() => {
  return () => {
    document.body.style.overflow = "auto";
  };
}, []);

  return (
    <>
      <Navbar />

      {/* HERO */}

      <section className="gallery-hero">
        <div className="container  gallery-hero-container">
          <span className="gallery-tag">OUR VISUAL STORY</span>

          <h1>
            Moments That Define
            <span> Outcess</span>
          </h1>

          <p>
            Explore our people, projects, milestones, events, and operational
            excellence through carefully captured moments.
          </p>

        </div>
      </section>

      {/* GALLERY */}

      <section className="gallery-section">
        <div className="gallery-grid">
          {IMAGES.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              style={{
                animationDelay: `${index * 70}ms`,
              }}
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.title}
                loading="lazy"
                className="gallery-image"
              />

              <div className="gallery-overlay">
                <div className="gallery-overlay-content">
                  <span className="gallery-category">{image.category}</span>

                  <h4>{image.title}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* LIGHTBOX */}

      {selectedIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="close-btn" onClick={closeLightbox}>
            <FaTimes />
          </button>

          <button
            className="nav-btn prev-btn"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            <FaChevronLeft />
          </button>

          <img
            src={IMAGES[selectedIndex].src}
            alt=""
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="nav-btn next-btn"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            <FaChevronRight />
          </button>

          <div className="lightbox-counter">
            {selectedIndex + 1} / {IMAGES.length}
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Gallery;
